import { EventsMap } from 'redux-beacon';
import { trackEvent } from '@app/shared/analytics';
import * as fromActions from './AI.actions';
import { EventType, SegmentEvent } from '@app/shared/interfaces';

const type = EventType.Action;

export const AIEvents: EventsMap = {};
